export const FETCH_PROFILE_LIST_SUCCESS = 'FETCH_PROFILE_LIST_SUCCESS';
export const UPDATE_PROFILE_FIELD_SUCCESS = 'UPDATE_PROFILE_FIELD_SUCCESS';
export const BLUR_PROFILE_FIELD_SUCCESS = 'BLUR_PROFILE_FIELD_SUCCESS';
export const RESET_PROFILE = 'RESET_PROFILE';
export const SET_POSITION_IDENTIFIER_SUCCESS = 'SET_POSITION_IDENTIFIER_SUCCESS';
export const ADD_MAPPED_FIELDS_TO_PROFILE = 'ADD_MAPPED_FIELDS_TO_PROFILE';
export const ADD_RULES_IDS_TO_PROFILE = 'ADD_RULES_IDS_TO_PROFILE';
export const UPDATE_TARGET_FIELDS_ID = 'UPDATE_TARGET_FIELDS_ID';
export const SET_PROFILE_FOR_EDITION = 'SET_PROFILE_FOR_EDITION';
export const FETCHING_PROFILE = 'FETCHING_PROFILE';
export const FETCH_PROFILE_COMPLETE = 'FETCH_PROFILE_COMPLETE';
export const FETCH_PROFILE_ERROR = 'FETCH_PROFILE_COMPLETE_ERROR';
export const FETCHING_PROFILES_LIST = 'FETCHING_PROFILES_LIST';
export const SET_PROFILE_EDITION_MODE = 'SET_PROFILE_EDITION_MODE';
export const RESET_PROFILE_EDITION_MODE = 'RESET_PROFILE_EDITION_MODE';



// WEBPACK FOOTER //
// ./src/redux/profiles/ProfilesConstants.js